import { findParentNodeOfType } from '@atlaskit/editor-prosemirror/utils';

// from platform/packages/editor/editor-plugin-find-replace/src/ui/styles.ts
var darkModeSearchMatchClass = 'search-match-dark';
var searchMatchExpandTitleClass = 'search-match-expand-title';
var selectedSearchMatchClass = 'selected-search-match';
export var findParentExpandNode = function findParentExpandNode(state) {
  return findParentNodeOfType(state.schema.nodes.nestedExpand)(state.selection) || findParentNodeOfType(state.schema.nodes.expand)(state.selection);
};
export var findReplaceExpandDecorations = [darkModeSearchMatchClass, searchMatchExpandTitleClass, selectedSearchMatchClass];